/**
 * @ngdoc    service
 * @module   csm.remoting
 * @name     csm.remoting.service:Sessions
 * @description
 * Parses `window.location.pathname` for session information and provides tools
 * for working with session based URLs.
 **/
/* @ngInject */
export function sessionProvider($windowProvider) {
  var location = $windowProvider.$get().location;
  var origin =
    location.protocol +
    '//' +
    location.hostname +
    (location.port ? ':' + location.port : '');
  var parts = location.pathname.match(
    /^(\/\(S\(([^\)]+)\)\))?(((?:\/[^\/]+)+)?(?:\/([^\/]*)))?$/
  );
  var sessionPath = parts[1] || ''; // "/(S(SessionID))"
  var sessionID = parts[2]; // "SessionID"
  var urlPathName = parts[3]; // "/Path/To/Page.xxx"
  var urlPath = parts[4] || ''; // "/Path/To"
  var urlName = parts[5]; // "Page.xxx"

  this.$get = function () {
    var svcs = {
      /**
       * @ngdoc      function
       * @name       getSessionAbsURL
       * @methodOf   csm.remoting.service:Sessions
       * @param      {string} handler  Service handler relative URL.
       * @returns    {string} Absolute session URL for `handler`.
       * @description
       * Returns "HostOrigin/(S(SessionID))handler" if `handler` starts with "/". Else,
       * returns unmodified `handler`.
       */
      getSessionAbsURL: function (handler) {
        return handler && handler[0] == '/'
          ? origin + sessionPath + handler
          : handler;
      },

      /**
       * @ngdoc      function
       * @name       getSessionURL
       * @methodOf   csm.remoting.service:Sessions
       * @param      {string} handler  Service handler relative URL.
       * @returns    {string} Session URL for `handler`.
       * @description
       * Returns "/(S(SessionID))handler" if `handler` starts with "/". Else,
       * returns unmodified `handler`.
       */
      getSessionURL: function (handler) {
        return handler && handler[0] == '/' ? sessionPath + handler : handler;
      },

      /**
       * @ngdoc      property
       * @name       sessionPath
       * @propertyOf csm.remoting.service:Sessions
       * @description
       * Returns "/(S(SessionID))" from "/(S(SessionID))/Path/To/Page.xxx".
       */
      sessionPath: sessionPath,

      /**
       * @ngdoc      property
       * @name       sessionID
       * @propertyOf csm.remoting.service:Sessions
       * @description
       * Returns "SessionID" from "/(S(SessionID))/Path/To/Page.xxx".
       */
      sessionID: sessionID,

      /**
       * @ngdoc      property
       * @name       urlPathName
       * @propertyOf csm.remoting.service:Sessions
       * @description
       * Returns "/Path/To/Page.xxx" from "/(S(SessionID))/Path/To/Page.xxx".
       */
      urlPathName: urlPathName,

      /**
       * @ngdoc      property
       * @name       urlPath
       * @propertyOf csm.remoting.service:Sessions
       * @description
       * Returns "/Path/To" from "/(S(SessionID))/Path/To/Page.xxx".
       */
      urlPath: urlPath,

      /**
       * @ngdoc      property
       * @name       urlName
       * @propertyOf csm.remoting.service:Sessions
       * @description
       * Returns "Page.xxx" from "/(S(SessionID))/Path/To/Page.xxx".
       */
      urlName: urlName
    };

    return Object.defineProperties(svcs, {
      /**
       * @ngdoc      property
       * @name       absPath
       * @propertyOf csm.remoting.service:Sessions
       * @description
       * Returns "HostOrigin/(S(SessionID))/Path/To" from "HostOrigin/(S(SessionID))/Path/To/Page.xxx".
       */
      absPath: {
        get: function () {
          return origin + sessionPath + urlPath;
        }
      },

      /**
       * @ngdoc      property
       * @name       absPathName
       * @propertyOf csm.remoting.service:Sessions
       * @description
       * Returns "HostOrigin/(S(SessionID))/Path/To/Page.xxx".
       */
      absPathName: {
        get: function () {
          return origin + sessionPath + urlPathName;
        }
      }
    });
  };
}

sessionProvider.$inject = ['$windowProvider'];